import router from '@/modules/paymentMethods/router'
export default {
  router,
}
